import * as React from "react"
import type { IconProps } from "../types"

const Pdf = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "#DF1C41", size = 36, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 36 36"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M32.1429 32.1429C32.1429 32.8249 31.872 33.4789 31.3897 33.9612C30.9075 34.4434 30.2534 34.7143 29.5715 34.7143H6.42861C5.74662 34.7143 5.09257 34.4434 4.61033 33.9612C4.1281 33.4789 3.85718 32.8249 3.85718 32.1429V3.8572C3.85718 3.17521 4.1281 2.52116 4.61033 2.03892C5.09257 1.55668 5.74662 1.28577 6.42861 1.28577H23.1429L32.1429 10.2858V32.1429Z"
        />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.6286 9.04379C10.3012 10.0286 24.1715 26.7429 25.6501 22.9192C27.1312 19.0929 7.43148 24.0249 10.6766 26.7429C13.9192 29.4635 16.9535 8.05636 13.6286 9.04379Z"
        />
      </svg>
    )
  }
)
Pdf.displayName = "Pdf"

export default Pdf
